export const countryData = {
  // 아시아 태평양
  'South Korea': { coords: [37.5665, 126.9780], koreanName: '대한민국' },
  'Japan': { coords: [36.2048, 138.2529], koreanName: '일본' },
  'China': { coords: [35.8617, 104.1954], koreanName: '중국' },
  'India': { coords: [20.5937, 78.9629], koreanName: '인도' },
  'Thailand': { coords: [15.8700, 100.9925], koreanName: '태국' },
  'Vietnam': { coords: [14.0583, 108.2772], koreanName: '베트남' },
  'Singapore': { coords: [1.3521, 103.8198], koreanName: '싱가포르' },
  'Indonesia': { coords: [-0.7893, 113.9213], koreanName: '인도네시아' },
  'Philippines': { coords: [12.8797, 121.7740], koreanName: '필리핀' },
  'Malaysia': { coords: [4.2105, 101.9758], koreanName: '말레이시아' },
  'Taiwan': { coords: [23.6978, 120.9605], koreanName: '대만' },
  'Hong Kong': { coords: [22.3193, 114.1694], koreanName: '홍콩' },
  'Macao': { coords: [22.1987, 113.5439], koreanName: '마카오' },
  'Mongolia': { coords: [47.9129, 106.9318], koreanName: '몽골' },
  'North Korea': { coords: [40.3399, 127.5101], koreanName: '북한' },
  'Nepal': { coords: [28.3949, 84.1240], koreanName: '네팔' },
  'Sri Lanka': { coords: [7.8731, 80.7718], koreanName: '스리랑카' },
  'Pakistan': { coords: [30.3753, 69.3451], koreanName: '파키스탄' },
  'Bangladesh': { coords: [23.6850, 90.3563], koreanName: '방글라데시' },
  'Myanmar': { coords: [21.9162, 95.9560], koreanName: '미얀마' },
  'Cambodia': { coords: [12.5657, 104.9910], koreanName: '캄보디아' },
  'Laos': { coords: [19.8563, 102.4955], koreanName: '라오스' },
  'Brunei': { coords: [4.5353, 114.7277], koreanName: '브루나이' },
  'Bhutan': { coords: [27.5142, 90.4336], koreanName: '부탄' },
  'Maldives': { coords: [3.2028, 73.2207], koreanName: '몰디브' },
  'Afghanistan': { coords: [33.9391, 67.7100], koreanName: '아프가니스탄' },
  'Uzbekistan': { coords: [41.3775, 64.5853], koreanName: '우즈베키스탄' },
  'Kazakhstan': { coords: [48.0196, 66.9237], koreanName: '카자흐스탄' },
  'Kyrgyzstan': { coords: [41.2044, 74.7661], koreanName: '키르기스스탄' },
  'Tajikistan': { coords: [38.8610, 71.2761], koreanName: '타지키스탄' },
  'Turkmenistan': { coords: [38.9697, 59.5563], koreanName: '투르크메니스탄' },
  
  // 오세아니아
  'Australia': { coords: [-25.2744, 133.7751], koreanName: '호주' },
  'New Zealand': { coords: [-40.9006, 174.8860], koreanName: '뉴질랜드' },
  'Fiji': { coords: [-16.7784, 179.4144], koreanName: '피지' },
  'Papua New Guinea': { coords: [-6.3149, 143.9555], koreanName: '파푸아뉴기니' },
  'Samoa': { coords: [-13.7590, -172.1046], koreanName: '사모아' },
  'Tonga': { coords: [-21.1789, -175.1982], koreanName: '통가' },
  'Vanuatu': { coords: [-15.3767, 166.9592], koreanName: '바누아투' },
  'Solomon Islands': { coords: [-9.6457, 160.1562], koreanName: '솔로몬제도' },
  'Palau': { coords: [7.5150, 134.5825], koreanName: '팔라우' },
  'Marshall Islands': { coords: [7.1315, 171.1845], koreanName: '마셜제도' },
  'Micronesia': { coords: [7.4256, 150.5508], koreanName: '미크로네시아' },
  'Nauru': { coords: [-0.5228, 166.9315], koreanName: '나우루' },
  'Kiribati': { coords: [-3.3704, -168.7340], koreanName: '키리바시' },
  'Tuvalu': { coords: [-7.1095, 177.6493], koreanName: '투발루' },
  
  // 미국령 태평양 지역
  'Guam': { coords: [13.4443, 144.7937], koreanName: '괌' },
  'Northern Mariana Islands': { coords: [17.3308, 145.3846], koreanName: '북마리아나제도(사이판)' },
  'American Samoa': { coords: [-14.2710, -170.1322], koreanName: '아메리칸사모아' },
  'US Virgin Islands': { coords: [18.0001, -64.8199], koreanName: '미국령 버진아일랜드' },
  'Puerto Rico': { coords: [18.2208, -66.5901], koreanName: '푸에르토리코' },
  
  // 유럽
  'United Kingdom': { coords: [55.3781, -3.4360], koreanName: '영국' },
  'France': { coords: [46.6034, 2.2137], koreanName: '프랑스' },
  'Germany': { coords: [51.1657, 10.4515], koreanName: '독일' },
  'Italy': { coords: [41.8719, 12.5674], koreanName: '이탈리아' },
  'Spain': { coords: [40.4637, -3.7492], koreanName: '스페인' },
  'Netherlands': { coords: [52.1326, 5.2913], koreanName: '네덜란드' },
  'Belgium': { coords: [50.5039, 4.4699], koreanName: '벨기에' },
  'Switzerland': { coords: [46.8182, 8.2275], koreanName: '스위스' },
  'Austria': { coords: [47.5162, 14.5501], koreanName: '오스트리아' },
  'Sweden': { coords: [60.1282, 18.6435], koreanName: '스웨덴' },
  'Norway': { coords: [60.4720, 8.4689], koreanName: '노르웨이' },
  'Denmark': { coords: [56.2639, 9.5018], koreanName: '덴마크' },
  'Finland': { coords: [61.9241, 25.7482], koreanName: '핀란드' },
  'Poland': { coords: [51.9194, 19.1451], koreanName: '폴란드' },
  'Czech Republic': { coords: [49.8175, 15.4730], koreanName: '체코' },
  'Portugal': { coords: [39.3999, -8.2245], koreanName: '포르투갈' },
  'Ireland': { coords: [53.4129, -8.2439], koreanName: '아일랜드' },
  'Scotland': { coords: [56.4907, -4.2026], koreanName: '스코틀랜드' },
  'Wales': { coords: [52.1307, -3.7837], koreanName: '웨일스' },
  'Iceland': { coords: [64.9631, -19.0208], koreanName: '아이슬란드' },
  'Croatia': { coords: [45.1000, 15.2000], koreanName: '크로아티아' },
  'Hungary': { coords: [47.1625, 19.5033], koreanName: '헝가리' },
  'Romania': { coords: [45.9432, 24.9668], koreanName: '루마니아' },
  'Bulgaria': { coords: [42.7339, 25.4858], koreanName: '불가리아' },
  'Ukraine': { coords: [48.3794, 31.1656], koreanName: '우크라이나' },
  'Russia': { coords: [61.5240, 105.3188], koreanName: '러시아' },
  'Greece': { coords: [39.0742, 21.8243], koreanName: '그리스' },
  'Turkey': { coords: [38.9637, 35.2433], koreanName: '튀르키예' },
  'Serbia': { coords: [44.0165, 21.0059], koreanName: '세르비아' },
  'Bosnia and Herzegovina': { coords: [43.9159, 17.6791], koreanName: '보스니아 헤르체고비나' },
  'Montenegro': { coords: [42.7087, 19.3744], koreanName: '몬테네그로' },
  'Slovenia': { coords: [46.1512, 14.9955], koreanName: '슬로베니아' },
  'Slovakia': { coords: [48.6690, 19.6990], koreanName: '슬로바키아' },
  'Estonia': { coords: [58.5953, 25.0136], koreanName: '에스토니아' },
  'Latvia': { coords: [56.8796, 24.6032], koreanName: '라트비아' },
  'Lithuania': { coords: [55.1694, 23.8813], koreanName: '리투아니아' },
  'Belarus': { coords: [53.7098, 27.9534], koreanName: '벨라루스' },
  'Moldova': { coords: [47.4116, 28.3699], koreanName: '몰도바' },
  'North Macedonia': { coords: [41.6086, 21.7453], koreanName: '북마케도니아' },
  'Albania': { coords: [41.1533, 20.1683], koreanName: '알바니아' },
  'Kosovo': { coords: [42.6026, 20.9030], koreanName: '코소보' },
  'Malta': { coords: [35.9375, 14.3754], koreanName: '몰타' },
  'Cyprus': { coords: [35.1264, 33.4299], koreanName: '키프로스' },
  'Luxembourg': { coords: [49.8153, 6.1296], koreanName: '룩셈부르크' },
  'Monaco': { coords: [43.7384, 7.4246], koreanName: '모나코' },
  'Vatican City': { coords: [41.9029, 12.4534], koreanName: '바티칸' },
  'San Marino': { coords: [43.9424, 12.4578], koreanName: '산마리노' },
  'Andorra': { coords: [42.5063, 1.5218], koreanName: '안도라' },
  'Liechtenstein': { coords: [47.1660, 9.5554], koreanName: '리히텐슈타인' },
  
  // 북미
  'United States': { coords: [39.8283, -98.5795], koreanName: '미국' },
  'Canada': { coords: [56.1304, -106.3468], koreanName: '캐나다' },
  'Mexico': { coords: [23.6345, -102.5528], koreanName: '멕시코' },
  'Guatemala': { coords: [15.7835, -90.2308], koreanName: '과테말라' },
  'Belize': { coords: [17.1899, -88.4976], koreanName: '벨리즈' },
  'El Salvador': { coords: [13.7942, -88.8965], koreanName: '엘살바도르' },
  'Honduras': { coords: [15.2000, -86.2419], koreanName: '온두라스' },
  'Nicaragua': { coords: [12.265, -85.2072], koreanName: '니카라과' },
  'Costa Rica': { coords: [9.7489, -83.7534], koreanName: '코스타리카' },
  'Panama': { coords: [8.4380, -80.9821], koreanName: '파나마' },
  
  // 카리브해
  'Cuba': { coords: [21.5218, -77.7812], koreanName: '쿠바' },
  'Jamaica': { coords: [18.1096, -77.2975], koreanName: '자메이카' },
  'Haiti': { coords: [18.9712, -72.2852], koreanName: '아이티' },
  'Dominican Republic': { coords: [18.7357, -70.1627], koreanName: '도미니카공화국' },
  'Bahamas': { coords: [25.0343, -77.3963], koreanName: '바하마' },
  'Barbados': { coords: [13.1939, -59.5432], koreanName: '바베이도스' },
  'Trinidad and Tobago': { coords: [10.6918, -61.2225], koreanName: '트리니다드 토바고' },
  'Saint Lucia': { coords: [13.9094, -60.9789], koreanName: '세인트루시아' },
  'Grenada': { coords: [12.1165, -61.6790], koreanName: '그레나다' },
  'Saint Vincent and the Grenadines': { coords: [12.9843, -61.2872], koreanName: '세인트빈센트 그레나딘' },
  'Antigua and Barbuda': { coords: [17.0608, -61.7964], koreanName: '앤티가 바부다' },
  'Dominica': { coords: [15.4150, -61.3710], koreanName: '도미니카' },
  'Saint Kitts and Nevis': { coords: [17.3578, -62.7830], koreanName: '세인트키츠 네비스' },
  
  // 남미
  'Brazil': { coords: [-14.2350, -51.9253], koreanName: '브라질' },
  'Argentina': { coords: [-38.4161, -63.6167], koreanName: '아르헨티나' },
  'Chile': { coords: [-35.6751, -71.5430], koreanName: '칠레' },
  'Peru': { coords: [-9.1900, -75.0152], koreanName: '페루' },
  'Colombia': { coords: [4.5709, -74.2973], koreanName: '콜롬비아' },
  'Venezuela': { coords: [6.4238, -66.5897], koreanName: '베네수엘라' },
  'Ecuador': { coords: [-1.8312, -78.1834], koreanName: '에콰도르' },
  'Bolivia': { coords: [-16.2902, -63.5887], koreanName: '볼리비아' },
  'Paraguay': { coords: [-23.4425, -58.4438], koreanName: '파라과이' },
  'Uruguay': { coords: [-32.5228, -55.7658], koreanName: '우루과이' },
  'Guyana': { coords: [4.8604, -58.9302], koreanName: '가이아나' },
  'Suriname': { coords: [3.9193, -56.0278], koreanName: '수리남' },
  'French Guiana': { coords: [3.9339, -53.1258], koreanName: '프랑스령 기아나' },
  
  // 아프리카
  'South Africa': { coords: [-30.5595, 22.9375], koreanName: '남아프리카' },
  'Egypt': { coords: [26.8206, 30.8025], koreanName: '이집트' },
  'Morocco': { coords: [31.7917, -7.0926], koreanName: '모로코' },
  'Kenya': { coords: [-0.0236, 37.9062], koreanName: '케냐' },
  'Tanzania': { coords: [-6.3690, 34.8888], koreanName: '탄자니아' },
  'Uganda': { coords: [1.3733, 32.2903], koreanName: '우간다' },
  'Rwanda': { coords: [-1.9403, 29.8739], koreanName: '르완다' },
  'Ethiopia': { coords: [9.1450, 40.4897], koreanName: '에티오피아' },
  'Nigeria': { coords: [9.0820, 8.6753], koreanName: '나이지리아' },
  'Ghana': { coords: [7.9465, -1.0232], koreanName: '가나' },
  'Senegal': { coords: [14.4974, -14.4524], koreanName: '세네갈' },
  'Mali': { coords: [17.5707, -3.9962], koreanName: '말리' },
  'Burkina Faso': { coords: [12.2383, -1.5616], koreanName: '부르키나파소' },
  'Niger': { coords: [17.6078, 8.0817], koreanName: '니제르' },
  'Chad': { coords: [15.4542, 18.7322], koreanName: '차드' },
  'Sudan': { coords: [12.8628, 30.2176], koreanName: '수단' },
  'South Sudan': { coords: [6.8770, 31.3070], koreanName: '남수단' },
  'Algeria': { coords: [28.0339, 1.6596], koreanName: '알제리' },
  'Tunisia': { coords: [33.8869, 9.5375], koreanName: '튀니지' },
  'Libya': { coords: [26.3351, 17.2283], koreanName: '리비아' },
  'Botswana': { coords: [-22.3285, 24.6849], koreanName: '보츠와나' },
  'Namibia': { coords: [-22.9576, 18.4904], koreanName: '나미비아' },
  'Zimbabwe': { coords: [-19.0154, 29.1549], koreanName: '짐바브웨' },
  'Zambia': { coords: [-13.1339, 27.8493], koreanName: '잠비아' },
  'Malawi': { coords: [-13.2543, 34.3015], koreanName: '말라위' },
  'Mozambique': { coords: [-18.6657, 35.5296], koreanName: '모잠비크' },
  'Madagascar': { coords: [-18.7669, 46.8691], koreanName: '마다가스카르' },
  'Mauritius': { coords: [-20.3484, 57.5522], koreanName: '모리셔스' },
  'Seychelles': { coords: [-4.6796, 55.4920], koreanName: '세이셸' },
  'Comoros': { coords: [-11.8750, 43.8722], koreanName: '코모로' },
  'Djibouti': { coords: [11.8251, 42.5903], koreanName: '지부티' },
  'Eritrea': { coords: [15.1794, 39.7823], koreanName: '에리트레아' },
  'Somalia': { coords: [5.1521, 46.1996], koreanName: '소말리아' },
  'Democratic Republic of Congo': { coords: [-4.0383, 21.7587], koreanName: '콩고민주공화국' },
  'Republic of Congo': { coords: [-0.2280, 15.8277], koreanName: '콩고공화국' },
  'Central African Republic': { coords: [6.6111, 20.9394], koreanName: '중앙아프리카공화국' },
  'Cameroon': { coords: [7.3697, 12.3547], koreanName: '카메룬' },
  'Equatorial Guinea': { coords: [1.6508, 10.2679], koreanName: '적도기니' },
  'Gabon': { coords: [-0.8037, 11.6094], koreanName: '가봉' },
  'São Tomé and Príncipe': { coords: [0.1864, 6.6131], koreanName: '상투메 프린시페' },
  'Cape Verde': { coords: [16.5388, -24.0132], koreanName: '카보베르데' },
  'Guinea-Bissau': { coords: [11.8037, -15.1804], koreanName: '기니비사우' },
  'Guinea': { coords: [9.9456, -9.6966], koreanName: '기니' },
  'Sierra Leone': { coords: [8.460555, -11.779889], koreanName: '시에라리온' },
  'Liberia': { coords: [6.4281, -9.4295], koreanName: '라이베리아' },
  'Ivory Coast': { coords: [7.5400, -5.5471], koreanName: '코트디부아르' },
  'Togo': { coords: [8.6195, 0.8248], koreanName: '토고' },
  'Benin': { coords: [9.3077, 2.3158], koreanName: '베냉' },
  'Lesotho': { coords: [-29.6100, 28.2336], koreanName: '레소토' },
  'Eswatini': { coords: [-26.5225, 31.4659], koreanName: '에스와티니' },
  
  // 중동
  'Israel': { coords: [31.0461, 34.8516], koreanName: '이스라엘' },
  'Palestine': { coords: [31.9522, 35.2332], koreanName: '팔레스타인' },
  'Jordan': { coords: [30.5852, 36.2384], koreanName: '요르단' },
  'Lebanon': { coords: [33.8547, 35.8623], koreanName: '레바논' },
  'Syria': { coords: [34.8021, 38.9968], koreanName: '시리아' },
  'Iraq': { coords: [33.2232, 43.6793], koreanName: '이라크' },
  'Iran': { coords: [32.4279, 53.6880], koreanName: '이란' },
  'UAE': { coords: [23.4241, 53.8478], koreanName: 'UAE' },
  'Saudi Arabia': { coords: [23.8859, 45.0792], koreanName: '사우디아라비아' },
  'Kuwait': { coords: [29.3117, 47.4818], koreanName: '쿠웨이트' },
  'Qatar': { coords: [25.3548, 51.1839], koreanName: '카타르' },
  'Bahrain': { coords: [25.9304, 50.6378], koreanName: '바레인' },
  'Oman': { coords: [21.4735, 55.9754], koreanName: '오만' },
  'Yemen': { coords: [15.5527, 48.5164], koreanName: '예멘' },
  'Armenia': { coords: [40.0691, 45.0382], koreanName: '아르메니아' },
  'Azerbaijan': { coords: [40.1431, 47.5769], koreanName: '아제르바이잔' },
  'Georgia': { coords: [42.3154, 43.3569], koreanName: '조지아' }
};

// 방문 횟수에 따른 색상과 크기
export const getVisitStyle = (visits) => {
  const styles = {
    1: { color: '#10b981', size: 0.5, glow: '#10b98180' },
    2: { color: '#f59e0b', size: 0.6, glow: '#f59e0b80' },
    3: { color: '#3b82f6', size: 0.7, glow: '#3b82f680' },
    4: { color: '#8b5cf6', size: 0.8, glow: '#8b5cf680' },
    5: { color: '#ef4444', size: 0.9, glow: '#ef444480' }
  };
  return styles[Math.min(visits, 5)] || styles[5];
};

// 지구본 텍스처 설정
export const getGlobeTextures = (mode) => {
  const textures = {
    satellite: {
      globe: '//unpkg.com/three-globe/example/img/earth-day.jpg',
      bump: '//unpkg.com/three-globe/example/img/earth-topology.png'
    },
    night: {
      globe: '//unpkg.com/three-globe/example/img/earth-night.jpg',
      bump: '//unpkg.com/three-globe/example/img/earth-topology.png'
    },
    topographic: {
      globe: '//unpkg.com/three-globe/example/img/earth-blue-marble.jpg',
      bump: '//unpkg.com/three-globe/example/img/earth-topology.png'
    }
  };
  return textures[mode] || textures.satellite;
};
